var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.autocompleteResult && _vm.autocompleteResult.length
        ? [
            _c(
              "div",
              { attrs: { "data-testing": "autocomplete-list" } },
              _vm._l(_vm.autocompleteResult, function(item, index) {
                return _c(
                  "a",
                  {
                    key: index,
                    staticClass: "autocomplete-suggestion",
                    class: _vm.paddingClasses,
                    style: _vm.paddingInlineStyles,
                    attrs: {
                      "aria-label": "autocompleteResult",
                      href: _vm.getTargetUrl(item),
                      tabindex: "0"
                    }
                  },
                  [
                    _vm.showImages
                      ? _c("div", { staticClass: "image flex-shrink-0 mr-3" }, [
                          item.image
                            ? _c("img", {
                                attrs: {
                                  alt: "search-suggestion",
                                  src: item.image
                                }
                              })
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "label overflow-hidden",
                        class: {
                          compact:
                            _vm.showAdditionalInformation &&
                            item.beforeLabel &&
                            item.afterLabel
                        }
                      },
                      [
                        _vm.showAdditionalInformation && item.beforeLabel
                          ? _c(
                              "p",
                              { staticClass: "small mb-0 text-truncate" },
                              [_vm._v(_vm._s(item.beforeLabel))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "mb-0 text-truncate",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getHighlightedLabel(item.label)
                            )
                          }
                        }),
                        _vm._v(" "),
                        _vm.showAdditionalInformation && item.afterLabel
                          ? _c(
                              "p",
                              { staticClass: "small mb-0 text-truncate" },
                              [_vm._v(_vm._s(item.afterLabel))]
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _vm.showCount && item.count > 0
                      ? _c("div", { staticClass: "count" }, [
                          _c("span", [_vm._v(_vm._s(item.count))])
                        ])
                      : _vm._e()
                  ]
                )
              }),
              0
            )
          ]
        : [
            _c(
              "p",
              {
                staticClass: "text-muted",
                class: _vm.paddingClasses,
                style: _vm.paddingInlineStyles
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$translate(
                        "Bigtex5::Template.itemSearchSuggestionNoResults"
                      )
                    ) +
                    "\n        "
                )
              ]
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }